'use client';

import iconCoinSmall from '@/assets/images/icons/coin-small.png';
import { useState } from 'react';
import IconTextUnit from '../../../../components/ui/IconTextUnit/IconTextUnit';
import ModalBase from '../../../../components/ui/ModalBase/ModalBase';
import layoutStyles from '../../../../styles/modules/layout.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { formatCurrency } from '../../../../utils/formatters';
import styles from './PurchaseHelpModal.module.scss';

type Props = {
  total: number;
  web: number;
  app: number;
};

function PurchaseHelpModal({ total, web, app }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`${styles.coinHelpText} ${utilsStyles.mtXSmall}`}>
      <button type='button' className={`${utilsStyles.textLink} ${styles.noPadding}`} onClick={() => setIsOpen(true)}>
        利用可能なコインについて
      </button>
      <ModalBase isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <div className={`${utilsStyles.textSmall} ${layoutStyles.modalPadding}`}>
          <div className={layoutStyles.modalTitle}>利用可能なコインについて</div>
          <div className={`${utilsStyles.flexRowNowrap} ${layoutStyles.alignCenter} ${utilsStyles.spaceBetween}`}>
            <span className={`${utilsStyles.textBold} ${styles.itemSectionTitle}`}>利用可能なコイン</span>
            <IconTextUnit
              imgSrc={iconCoinSmall.src}
              unit={'coin'}
              text={formatCurrency(total)}
              isUnitBold
              textSize='xLarge'
            />
          </div>
          <hr className={utilsStyles.pinkishgrayBgColor} />
          <div className={utilsStyles.mtSmall} />
          <p className={`${styles.itemSectionTitle}`}>内訳</p>
          <div className={styles.itemIndent}>
            <div className={utilsStyles.mtXSmall}>
              <div className={`${utilsStyles.flexRowNowrap} ${utilsStyles.alignCenter} ${utilsStyles.spaceBetween}`}>
                <span className={`${styles.itemSectionTitle} ${utilsStyles.textBold}`}>Web</span>

                <IconTextUnit
                  imgSrc={iconCoinSmall.src}
                  unit={'coin'}
                  text={formatCurrency(web)}
                  isUnitBold
                  textSize='xLarge'
                />
              </div>
              <hr className={utilsStyles.pinkishgrayBgColor} />
              <div className={utilsStyles.mtXSmall} />
              <div className={`${utilsStyles.flexRowNowrap} ${utilsStyles.alignCenter} ${utilsStyles.spaceBetween}`}>
                <span className={`${styles.itemSectionTitle} ${utilsStyles.textBold}`}>App</span>

                <IconTextUnit
                  imgSrc={iconCoinSmall.src}
                  unit={'coin'}
                  text={formatCurrency(app)}
                  isUnitBold
                  textSize='xLarge'
                />
              </div>
              <hr className={utilsStyles.pinkishgrayBgColor} />
            </div>
          </div>
          <div className={utilsStyles.mtXSmall}>
            <p className={utilsStyles.textXSmall}>
              ・アプリで購入したコインは、その購入したOSでのみ利用可能です。
              <br />
              ・このOSでご利用いただけないコインは「その他利用不可のコイン」に分類されます。
            </p>
          </div>
        </div>
      </ModalBase>
    </div>
  );
}

export default PurchaseHelpModal;
